import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Link2, ArrowRight } from "lucide-react";

const Footer = () => {
  return (
    <footer className="relative bg-[#ebebeb] text-white overflow-hidden">
      {/* subtle page glow */}
      <div className="pointer-events-none absolute inset-0 opacity-60">
        <div className="absolute left-[-120px] top-[-120px] h-[380px] w-[380px] rounded-full bg-emerald-400/10 blur-3xl" />
        <div className="absolute right-[-160px] bottom-[-140px] h-[460px] w-[460px] rounded-full bg-sky-500/10 blur-3xl" />
      </div>

      <div className="relative mx-auto w-[90%] 2xl:w-[70%] py-4">
        {/* ================= CTA ================= */}
        <div className="relative overflow-hidden rounded-3xl">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-emerald-400/25 via-white/10 to-sky-400/20" />

          <div className="relative rounded-3xl bg-gradient-to-br from-[#0b2b40] via-[#081c2a] to-[#05070a] p-[1px]">
            <div className="relative overflow-hidden rounded-3xl bg-[#07131d]/90 backdrop-blur-xl">
              <div className="pointer-events-none absolute -left-28 -top-28 h-72 w-72 rounded-full bg-emerald-400/18 blur-3xl" />
              <div className="pointer-events-none absolute -right-24 -bottom-24 h-72 w-72 rounded-full bg-sky-400/12 blur-3xl" />

              <div className="relative grid items-center gap-10 px-8 py-10 md:grid-cols-12 md:px-12 md:py-12">
                {/* left */}
                <div className="md:col-span-8">
                  <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/70">
                    Premium Partner
                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
                    Bewertung · Web · Marketing
                  </div>

                  <h2 className="mt-4 h2-mb h2-md h2-lg h2-2xl !text-white">
                    Ihr Partner für Bewertungsmanagement,{" "}
                    <span className="text-white/85">Webdesign</span> &{" "}
                    <span className="text-[#6be36a]">Marketing</span>
                  </h2>

                  <h3 className="mt-3 max-w-xl text-sm text-white/60">
                    Durchdachte digitale Lösungen für nachhaltigen Unternehmenserfolg.
                  </h3>

                  <div className="mt-6 flex flex-wrap gap-3">
                    <Link
                      to="/kontak"
                      className="group inline-flex items-center gap-2 rounded-xl bg-white px-5 py-2.5 text-sm font-semibold text-black shadow transition hover:bg-white/90"
                    >
                      Kontakt
                      <ArrowRight size={16} className="transition group-hover:translate-x-0.5" />
                    </Link>

                    <Link
                      to="/unverbindliches-angebot"
                      className="inline-flex items-center rounded-xl border border-white/15 bg-white/5 px-5 py-2.5 text-sm font-semibold text-white/85 transition hover:bg-white/10"
                    >
                      Angebot einholen
                    </Link>
                  </div>
                </div>

                {/* right visual */}
                <div className="md:col-span-4">
                  <div className="relative mx-auto h-[240px] w-[240px] md:h-[280px] md:w-[280px]">
                    <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-emerald-400/20 via-white/10 to-sky-400/15 blur-2xl" />
                    <div className="absolute inset-0 rounded-full border border-white/10 bg-white/5 backdrop-blur" />
                    <div className="absolute inset-6 rounded-full border border-white/10 bg-gradient-to-tr from-[#115b2999] to-black/40" />
                    <div className="absolute inset-10 rounded-full border border-white/10" />
                  </div>
                </div>
              </div>

              <div className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
          </div>
        </div>

        {/* ================= FOOTER CONTENT ================= */}
        <div className="mt-12 rounded-3xl border border-white/10 bg-[#081b2be8] p-7 backdrop-blur-xl md:p-10">
          <div className="grid gap-10 md:grid-cols-12">
            {/* brand */}
            <div className="md:col-span-5">
              <div className="text-3xl font-extrabold tracking-[0.35em] text-lime-300">
                UNEVA
              </div>
              <p className="mt-4 text-sm text-white/60">
                Ihr Partner für Bewertungsmanagement, Webdesign & Marketing
              </p>
            </div>

            {/* links */}
            <div className="md:col-span-3">
              <h4 className="mb-4 flex items-center gap-2 text-xs uppercase text-white/70">
                <Link2 size={15} className="text-emerald-300" />
                Link
              </h4>
              <ul className="space-y-3 text-sm text-white/60">
                <li><Link to="/" className="hover:text-white">Startseite</Link></li>
                <li><Link to="/impressum" className="hover:text-white">Impressum</Link></li>
                <li><Link to="/datenschutzerklaerung" className="hover:text-white">Datenschutz</Link></li>
                <li><Link to="/kontak" className="hover:text-white">Kontakt</Link></li>
              </ul>
            </div>

            {/* contact */}
            <div className="md:col-span-4">
              <h4 className="mb-4 text-xs uppercase text-white/70">
                Wie du uns erreichst
              </h4>
              <ul className="space-y-4 text-sm text-white/60">
                <li className="flex gap-3">
                  <MapPin size={16} className="text-emerald-300" />
                  
Gelsenkirchenerstr. <br />12, 28199 Bremen
                </li>

                <li className="flex gap-3">
                  <Mail size={16} className="text-emerald-300" />
                  <a href="mailto:anfrage@uneva.de" className="hover:text-white">
                    anfrage@uneva.de
                  </a>
                </li>

                <li className="flex gap-3">
                  <Phone size={16} className="text-emerald-300" />
                  <a href="tel:+4942136583008" className="hover:text-white">
                    0421 36583008
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 border-t border-white/10 pt-6 text-xs text-white/45">
            © 2026 UNEVA 
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
